import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Table, TableCell, TableRow, TableBody } from '@mui/material';
import { BoldTableHead } from 'components/common/CommonStyles';

export const ContractDetailInfoComponent = ({ t, leasingOfferContractDataDetails }) => {
  return (
    <Table>
      <BoldTableHead>
        <TableRow>
          <TableCell>{t('RestructuringEdit.Contract.Detail.ItemName')}</TableCell>
          <TableCell>{t('RestructuringEdit.Contract.Detail.Brand')}</TableCell>
          <TableCell>{t('RestructuringEdit.Contract.Detail.Model')}</TableCell>
          <TableCell>{t('RestructuringEdit.Contract.Detail.Version')}</TableCell>
          <TableCell>{t('RestructuringEdit.Contract.Detail.AcquisitionPrice')}</TableCell>
          <TableCell>{t('RestructuringEdit.Contract.Detail.ChassisNumber')}</TableCell>
        </TableRow>
      </BoldTableHead>
      <TableBody>
        {leasingOfferContractDataDetails &&
          leasingOfferContractDataDetails.map((leasingOfferContractDataDetail, idx) => {
            return (
              <TableRow key={idx}>
                <TableCell>
                  <span>{leasingOfferContractDataDetail.assetName || ''}</span>
                </TableCell>
                <TableCell>
                  <span>{leasingOfferContractDataDetail.brand || ''}</span>
                </TableCell>
                <TableCell>
                  <span>{leasingOfferContractDataDetail.model || ''}</span>
                </TableCell>
                <TableCell>
                  <span>{leasingOfferContractDataDetail.version || ''}</span>
                </TableCell>
                <TableCell>
                  <span>{`${t('NUMBER', {
                    number: leasingOfferContractDataDetail.acquisitionPrice || ''
                  })} ${leasingOfferContractDataDetail.currencyName || ''}`}</span>
                </TableCell>
                <TableCell>
                  <span>{leasingOfferContractDataDetail.chassisNumber || ''}</span>
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

ContractDetailInfoComponent.propTypes = {
  t: PropTypes.func.isRequired,
  leasingOfferContractDataDetails: PropTypes.array
};

export default compose(withTranslation())(ContractDetailInfoComponent);
